/**
 * Take picture service
 *
 **/

app.factory('WebcamService', [function() {
    var JPEG_MIME = 'image/jpeg';
    // Keep in sync with Kronos IMAGE_JPEG_QUALITY (and Kore Image::JPEG_QUALITY).
    var JPEG_QUALITY = 0.90;

    return {
        width: null,
        height: null,

        startup: function(video, canvas, width, streaming) {
            this.width = width;

            navigator.mediaDevices.getUserMedia({ video: true, audio: false })
                .then(function(stream) {
                    video.srcObject = stream;
                    video.play();
                })
                .catch(function(err) {
                    console.log("An error occurred: " + err);
                });

            var self = this;
            video.addEventListener('canplay', function(ev) {
                if (!streaming) {
                    self.height = video.videoHeight / (video.videoWidth/self.width);
                    if (isNaN(self.height)) {
                        self.height = self.width / (4/3);
                    }
                    video.setAttribute('width', self.width);
                    video.setAttribute('height', self.height);
                    canvas.setAttribute('width',self.width);
                    canvas.setAttribute('height', self.height);
                    streaming = true;
                }
            }, false);

            this.clearphoto(canvas);
        },

        clearphoto: function(canvas) {
            var context = canvas.getContext('2d');
            context.fillStyle = "#AAA";
            context.fillRect(0, 0, canvas.width, canvas.height);

            return canvas.toDataURL(JPEG_MIME, JPEG_QUALITY);
        },

        takepicture: function(canvas) {
            var context = canvas.getContext('2d');
            if (this.width && this.height) {
                canvas.width = this.width;
                canvas.height = this.height;
                context.fillStyle = '#FFFFFF';
                context.fillRect(0, 0, canvas.width, canvas.height);
                context.drawImage(video, 0, 0, this.width, this.height);

                return canvas.toDataURL(JPEG_MIME, JPEG_QUALITY);
            }

            return this.clearphoto(canvas);
        }
    };
}]);
